import { ViteReactSSG } from 'vite-react-ssg';
import routes from '@/routes/routes';

// i18n
import './i18n';

// Styles
import './styles/fonts.css';
import './styles/reset.css';
import './styles/theme.css';

export const createRoot = ViteReactSSG(
  { routes },
);
